module.exports = __webpack_public_path__ + "static/screenshot1-62ee5604df71b3b9feeb1fb0ed2722d4.png";